<template>
    <div class="py-5">
        <div class="ml-5">
            <the-title parentcolor="orange">
                <slot slot="de">Ergebnisse</slot>
                <slot slot="en">Outcomes</slot>
            </the-title>
        </div>
        <div class="mb-5">
            <div class="main-carousel"
                 data-flickity='{ "cellAlign": "left", "contain": "true", "wrapAround": "true", "pageDots": "false", "adaptiveHeight": "true"}'
            >
                <div class="carousel-cell" v-for="spielplanItem in articleItem" :key="spielplanItem.ID" v-if="spielplanItem.anstoss">
                    <teaser-view :spielplan="spielplanItem"/>
                </div>
            </div>
        </div>

        <seperator />
    </div>
</template>

<script>

    import teaserView from './teaserView'
    import seperator from '../seperator'
    import TheTitle from '../TheTitle'


    export default {
        name: 'Ergebnisse',
        components: {
            seperator,
            teaserView,
            TheTitle
        },
        data() {
            return {

            }
        },
        props: {
            articleItem: {
                type: Object,
                default: () => {
                }
            }
        },
        mounted() {
            let sliderScript = document.createElement('script')
            sliderScript.setAttribute('src', 'https://api.pgsi2020.de/js/slider.js')
            document.head.appendChild(sliderScript)
        }
    }
</script>

<style>
    .sepWrap{
        vertical-align: top;
        margin: 0;
        height: 0;
        line-height: 1px;
    }
</style>